var React = require('react');

function Kemtvatt (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M73.6 80h10c.7 0 1.5.4 2 1a12.2 12.2 0 0 0 19.3.2l.2-.2c.4-.6 1.2-1 2-1h9.2a3 3 0 0 1 2.3 1.1l15.7 19.3c1 1.2.9 2.9-.2 4l-6 5.8a3 3 0 0 1-4.1 0l-6.3-6.1V150a3 3 0 0 1-3 3H77.1a3 3 0 0 1-3-3v-46l-6.3 6.3a3 3 0 0 1-4.2.1l-6.6-6a3 3 0 0 1-.3-4.1l14.5-19.1a3 3 0 0 1 2.4-1.2Z","stroke":"#000","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M38.5 107.5a57 57 0 0 1 114 0v64h-114v-64Z","stroke":"#000","strokeWidth":"5","key":1}),React.createElement("path",{"d":"M96 49v-2.1a14 14 0 0 1 3.5-9.2l.7-.8c1.8-2 3.1-4.5 2.5-7.1-.7-3-2.7-5.8-7-5.8-6 0-7.7 5.7-7.7 9.8","stroke":"#000","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

Kemtvatt.defaultProps = {"viewBox":"0 0 191 191","width":"191","height":"191","fill":"none"};

module.exports = Kemtvatt;

Kemtvatt.default = Kemtvatt;
